import { useProjectPermissions } from 'hooks/useProjectPermissions'
import { GANTT_STATUS } from '../../constants'
import LinkSection from '../LinkSection'
import GanttForm from './components/GanttForm'
import GanttLink from './components/GanttLink'

const Gantt = () => {
  const { projectInfo } = useProjectPermissions()

  const gantt = projectInfo?.ganttpro
  const ganttLink = gantt?.link ?? ''
  const hasGanttLink = !!gantt && gantt.status !== GANTT_STATUS.EMPTY
  const isProtected = gantt?.status === GANTT_STATUS.PROTECTED

  return (
    <LinkSection
      hasLink={hasGanttLink}
      addTitle="Добавить ссылку"
      editTitle="Редактировать"
      renderPublished={() => (
        <GanttLink link={ganttLink} checked={isProtected} />
      )}
      emptyText={'План-график проекта ещё не опубликован'}
      renderForm={({ onCancel }) => (
        <GanttForm gantt={gantt} onCancel={onCancel} />
      )}
    />
  )
}

export default Gantt
